import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import AsyncJob from "@/models/async-job";
import {AsyncJobStatus} from "@/assets/scripts/async-status";

@Module({ namespaced: true })
class AsyncModule extends VuexModule {
  [x: string]: any

  listAsyncJobs: AsyncJob[] | null = null;

  /**
   * Всего асинхронных задач
   */
  public get totalCount() {
    return this.listAsyncJobs?.length || 0;
  }

  /**
   * Количество асинхронных задач в работе
   */
  public get inWorkCount(): number {
    return this.asyncInWorkTasks?.length || 0;
  }

  /**
   * Количество завершенных асинхронных задач
   */
  public get completedCount(): number {
    return this.totalCount - this.inWorkCount;
  }

  /**
   * Список асинхронных задач
   */
  public get asyncJobs() {
    return this.listAsyncJobs || [];
  }

  /**
   * Список асинхронных задач в работе
   */
  public get asyncInWorkTasks() {
    return this.asyncJobs.filter(_ => _.status == AsyncJobStatus.PROCESS);
  }

  /**
   * Список идентификаторов асинхронных задач в работе
   */
  public get asyncInWorkTasksIds() {
    return this.asyncInWorkTasks.map(el => el.asyncId);
  }

  @Mutation
  setAsyncJobs(asyncJobs: AsyncJob[] = []) {
    this.listAsyncJobs = asyncJobs;
  }
}

export default AsyncModule;
